import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import { observer } from 'mobx-react';
import arrayMutators from 'final-form-arrays';
import { Drawer } from 'ksnm-common-ui/lib/Drawer';
import { Form as AntForm } from 'ksnm-common-ui/lib/Form';

import { designDrawerStore } from '@stores/designDrawerStore';

import { DesignInnerForm } from './DesignInnerForm';

function DesignInnerMenuDrawerComponent(): JSX.Element {
  const { form, setCustomForm } = designDrawerStore;

  const onClose = useCallback(() => {
    setCustomForm(null);
  }, [setCustomForm]);

  const onSubmit = useCallback(
    (values) => {
      if (form?.validate) {
        const validationResult = form.validate(values);
        if (validationResult) {
          return validationResult;
        }
      }
      form?.submit?.(values);
      setCustomForm(null);
      return undefined;
    },
    [form, setCustomForm],
  );

  return (
    <Drawer open width={700} onClose={onClose} title={form?.title}>
      <Form
        initialValues={form?.formData}
        onSubmit={onSubmit}
        subscription={{
          submitting: true,
        }}
        mutators={{
          ...arrayMutators,
          insert: ([name, index, value], state, { changeValue }) => {
            changeValue(state, name, (array) => {
              const copy = [...(array || [])];
              copy.splice(index, 0, value);
              return copy;
            });
          },
        }}
      >
        {() => (
          <AntForm layout="vertical">
            <DesignInnerForm />
          </AntForm>
        )}
      </Form>
    </Drawer>
  );
}

export const DesignInnerMenuDrawer = observer(DesignInnerMenuDrawerComponent);
